import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from 'src/app/adapters/event.service';

declare var UIkit: any;
@Component({
    selector: 'app-tisco-modal-waiting',
    templateUrl: './tisco-modal-waiting.component.html',
    styleUrls: ['./tisco-modal-waiting.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone:false
})
export class TiscoModalWaitingComponent implements OnInit {
    loadding:boolean = false
    constructor(
        private router: Router,
        private eventService:EventService
        
        ) { }

    ngOnInit() {
        this.eventService.loadding.subscribe((data) => {
            this.loadding = data
        });
     }

    showWaiting() {
        // Show Modal wating
        //UIkit.modal('.js-modal-wating').show();
    }
    hideWaiting() {
        // Hide Modal wating
        //UIkit.modal('.js-modal-wating').hide();
    }

}
